import React from 'react';
import Slider from 'react-slick';
import { Button } from '../../Atoms';
import { useNavigate, Link } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import { FaBuilding, FaCarSide, FaChargingStation } from "react-icons/fa";
import { HashLink } from 'react-router-hash-link';
import MonitorImage from '../../Assets/mobileApp/appScreens-c.webp'
import userauthentication from '../../Assets/home/14.png'
import remotemanagement from '../../Assets/home/11.png'
import hardwarediagnostic from '../../Assets/home/12.png'
import fleetmanagement from '../../Assets/home/16.png'
import dynamicloadmanagement from '../../Assets/home/15.png'
import customaccesscontrol from '../../Assets/home/13.png'
import carbonwallet from '../../Assets/home/18.png'
import security from '../../Assets/home/17.png'
import upi from '../../Assets/home/upi.png'
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import cmsandapp from '../../Assets/brochures/CMS_Brochure_VM.pdf';
import appstore from '../../Assets/shared/app_link_apple.svg';
import playstore from '../../Assets/shared/app_link_playstore.svg';


const logos = [
    { name: "Find EV Charging Stations", img: remotemanagement },
    { name: "Check realtime changer availability", img: hardwarediagnostic },
    { name: "Reserve your preferred time", img: customaccesscontrol },
    { name: "Pay with your preferred method", img: userauthentication },
    { name: "Start/Stop charging through a single tap", img: dynamicloadmanagement },
    { name: "Live Updates during charging sessions", img: fleetmanagement },
    { name: "Track your charging history", img: security },
    { name: "Route planning made easy", img: carbonwallet },    
];





const App = () => {
    const navigate = useNavigate();
    return (
        <section className=" containers-min mx-auto">
            <div >
                <div
                    className="min-h-[50vh] blade-margin-sm"
                >
                    <div className="2xl:pb-20 xl:pb-16 pb-12">
                        <h3 className="text-center font-gilroy">
                            Mobile Application <br /> for end user management
                        </h3>
                        <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                            We offer mobile app to support end-user management. This app can be used by end-users of
                            Infrastructure, Fleet and Business to manage their charging needs
                        </p>
                    </div>
                    <div className="bg-grey rounded-2xl p-6 md:p-8 space-y-6 md:space-y-8">
                        <div className='flex flex-col md:flex-row'>
                            <div className="w-full md:w-2/4">
                                <div className=" flex flex-col gap-2 flex-nowrap ">
                                    {/* <h4 className="card-title font-bold font-gilroy ">
                                        Mobile Application for end user management
                                    </h4>
                                    <span className="text-opacity-70 text-sm  sm:text-base  md:text-lg   max-w-lg xl:max-w-xl  pr-5">
                                        We offer mobile app to support end-user management. This app can be used by end-users of
                                        Infrastructure, Fleet and Business to manage their charging needs.
                                    </span> */}
                                    <div className="py-3 flex flex-col divide-y divider-grey">
                                        <div className="flex flex-col flex-nowrap gap-4 py-2  sm:py-4 lg:py-6">
                                            {/* <span className="font-semibold  text-lg xl:text-xl">
                                                Features
                                            </span> */}
                                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mt-6">
                                                {logos.map((car, index) => (
                                                    <div key={index} className="flex flex-col items-start">
                                                        <img
                                                            src={car.img}
                                                            alt={car.name}
                                                            className="w-12 h-12 sm:w-10 sm:h-10 transition-transform"
                                                        />
                                                        <p className="font-semibold text-sm sm:text-base text-gray-600 mt-2 font-poppins">{car.name}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="flex items-center py-2 sm:py-3 gap-3">
                                            <div onClick={() => navigate('/get-in-touch')}>
                                                <button
                                                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                                >
                                                    <span className="flex justify-center items-center">
                                                        <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                                        <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                                    </span>
                                                    Contact Us
                                                </button>
                                            </div>

                                            <div className='group cursor-pointer'>
                                                <a href="https://resources.verdemobility.com/files/CMS.pdf" target="_blank" className='text-gray-600'>
                                                    <button
                                                        className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                                    >
                                                        <span className="flex justify-center items-center">
                                                            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                                            <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                                        </span>
                                                        Brochure
                                                    </button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col items-center w-full md:w-2/4 group relative">
                                <img src={MonitorImage} alt="APP" />
                                <div className="flex flex-wrap md:gap-8 gap-4 items-center justify-center max-w-2xl w-full">
                                    <a
                                        href="https://apps.apple.com/in/app/verdemobility/id1622189313"
                                        className="max-w-[120px] md:max-w-[300px] md:min-w-[200px]"
                                        rel="noreferrer"
                                        target="_blank"
                                    >
                                        <span className="sr-only">Download IOS app</span>

                                        <img
                                            loading="lazy"
                                            src={appstore}
                                            className="py-2 "
                                            alt="app strore link"
                                        />
                                    </a>
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.verdemobility.ev.charger"
                                        className="max-w-[120px] md:max-w-[300px] md:min-w-[200px]"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span className="sr-only">Download Android app</span>

                                        <img
                                            loading="lazy"
                                            src={playstore}
                                            className="py-2"
                                            alt="play strore link"
                                        />
                                    </a>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default App;
